import "./index.css";
import type { IColumnProps } from "./types";
import { clsx } from "clsx";

export const Column = ({
  children,
  gap,
  padding,
  alignmentHorizontal = "start",
  alignmentVertical = "top",
  wrap = false,
  reverse = false,
  fullWidth = false,
  className,
}: IColumnProps) => {
  const rootClass = clsx(
    "nuco-column",
    gap && `nuco-column--gap-${gap}`,
    padding && `nuco-column--padding-${padding}`,
    `nuco-column--horizontal-${alignmentHorizontal}`,
    `nuco-column--vertical-${alignmentVertical}`,
    wrap && "nuco-column--wrap",
    reverse && "nuco-column--reverse",
    fullWidth && "nuco-column--fullWidth",
    className,
  );

  return <div className={rootClass}>{children}</div>;
};
